import { Intent } from "@blueprintjs/core";
import { ButtonWithDialog } from "@focus/focusUI";
import { useState } from "react";
import { ROLES, useRoles } from "../../hooks/useRoles";
import { useUserController } from "../../hooks/useUserController";
import type { Organization } from "../../types/users";
import { OrganizationForm } from "./OrganizationForm";

export const CreateOrganizationButton = () => {
  const { addOrganization } = useUserController();
  const { roles } = useRoles();
  const [acceptDisabled, setAcceptDisabled] = useState<boolean>(true);

  const isAdmin = roles.includes(ROLES.ADMIN);

  if (!isAdmin) return null; // Do not show button

  const emptyOrganization: Organization = {
    name: "",
  };

  return (
    <ButtonWithDialog<Organization>
      minimal
      icon="inherited-group"
      tooltipText="New organization"
      intent={Intent.NONE}
      defaultContent={emptyOrganization}
      onAccept={(newOrganization) => addOrganization(newOrganization)}
      form={({ content, onUpdate }) => (
        <OrganizationForm
          content={content}
          onUpdate={onUpdate}
          onValidityChange={(isValid) => setAcceptDisabled(!isValid)}
          readOnly={false}
        />
      )}
      disableAccept={acceptDisabled}
    />
  );
};
